export default "__VITE_ASSET__UJoA87ri__"